import { MenuButton, MenuItem } from '@carbon/react';

/** The right-panel types the three workspace lists open into. */
export type WorkspacesMenuType =
  'workspaces' | 'inventory-workspaces' | 'dca-workspaces';

export interface WorkspacesMenuProps {
  /** Type Curve workspaces count (from the header's workspaces collection). */
  typeCurveCount: number;
  /** Inventory workspaces count. */
  inventoryCount: number;
  /** DCA workspaces count. */
  dcaCount: number;
  /** Open the right sidebar for the chosen workspace type. */
  onOpen: (type: WorkspacesMenuType) => void;
}

/**
 * The Type Curve details page's "Workspaces" menu.
 *
 * Mirrors the "Create" menu's dropdown styling. Each item opens the right
 * sidebar listing that workspace type; the label carries its count. Type Curve
 * is live today; Inventory and DCA populate once the header advertises their
 * collection hrefs (backend branch), reading 0 until then.
 *
 * @param {WorkspacesMenuProps} props - Per-type counts and the panel opener.
 * @return {JSX.Element} The menu button.
 */
export const WorkspacesMenu = ({
  typeCurveCount,
  inventoryCount,
  dcaCount,
  onOpen,
}: WorkspacesMenuProps) => {
  return (
    <MenuButton
      label="Workspaces"
      kind="tertiary"
      size="md"
      menuAlignment="bottom-end"
    >
      <MenuItem
        label={`DCA (${dcaCount})`}
        onClick={() => onOpen('dca-workspaces')}
      />
      <MenuItem
        label={`Type Curve (${typeCurveCount})`}
        onClick={() => onOpen('workspaces')}
      />
      <MenuItem
        label={`Inventory (${inventoryCount})`}
        onClick={() => onOpen('inventory-workspaces')}
      />
    </MenuButton>
  );
};
